import * as z from "zod/v4";
import { AnalyticsFilterType } from "./analytics-filter-type";
import { makeReportFilterSchema } from "./base-report-filter";

export enum SalesChannelFilterQuery {
  IS_ANY = "isAny",
  IS_NONE = "isNone",
}

export const SalesChannelFilterSchema = makeReportFilterSchema(
  AnalyticsFilterType.SALES_CHANNEL,
  SalesChannelFilterQuery,
  z.array(z.string()),
);

export type SalesChannelFilter = z.infer<typeof SalesChannelFilterSchema>;
